// New teacher (SPEC §7.5).

import type { ApiResult } from "../../api/client";
import { fetchCourses } from "../../api/courses";
import { createTeacher, type TeacherFields } from "../../api/teachers";
import type { Course, Teacher } from "../../api/types";
import { t } from "../../i18n/i18n";
import { navigate } from "../../router";
import { showToast } from "../../ui/feedback";
import { createLoading, showPageProblem, startPage } from "../pageFrame";
import { buildTeacherForm } from "./teacherForm";

export async function renderTeacherCreatePage(container: HTMLElement): Promise<void> {
  const page: HTMLElement = startPage(container, t("teachers.newTeacher"));
  const loading: HTMLParagraphElement = createLoading();
  page.append(loading);
  const courses: ApiResult<Course[]> = await fetchCourses(false);
  loading.remove();
  if (courses.ok === false) {
    showPageProblem(page, courses.problem);
    return;
  }

  page.append(buildTeacherForm({
    teacher: null,
    courses: courses.data,
    save: (fields: TeacherFields): Promise<ApiResult<Teacher>> => createTeacher(fields),
    onSaved: (teacher: Teacher): void => {
      showToast(t("app.saved"));
      navigate(`/teachers/${teacher.id}`);
    },
  }));
}
